import { creditApplicationStateSelectors } from './creditApplicationStateSelectors'
import { FilteredCreditApplication } from './types/FilteredCreditApplication'
import { Enum } from './types/constants'
import { CustomerFeedback } from './types/CustomerFeedback'

export const creditApplicationContainerSelection = {
  renderComponent: (
    id: string | undefined,
    creditApplication: FilteredCreditApplication | null,
    customerFeedback: CustomerFeedback | null,
  ) => {
    const isReadyForFlinks = creditApplicationStateSelectors.isReadyForFlinks(creditApplication)
    const mustShowRequiredPhotoId = creditApplicationStateSelectors.mustShowRequiredPhotoId(creditApplication)
    const hasRequiredDocumentPendingForUpload =
      creditApplicationStateSelectors.hasRequiredDocumentPendingForUpload(creditApplication)
    const canPostQualify = creditApplicationStateSelectors.canPostQualify(creditApplication)
    const hasFailedPrequalify = creditApplicationStateSelectors.failedPrequalify(creditApplication)
    const hasPrequalifyDecision = creditApplicationStateSelectors.hasPrequalifyDecision(creditApplication)
    const canReviewFinalDecision = creditApplicationStateSelectors.canReviewFinalDecision(creditApplication)
    const hasFinalDecision = creditApplicationStateSelectors.hasFinalDecision(creditApplication)
    const isReadyForWorksheet = creditApplicationStateSelectors.isReadyForWorksheet(creditApplication)
    const failedToConfirmApplicantIdentity =
      creditApplicationStateSelectors.failedToConfirmApplicantIdentity(creditApplication)
    const failedToConfirmCoApplicantIdentity =
      creditApplicationStateSelectors.failedToConfirmCoApplicantIdentity(creditApplication)
    const isAwaitingPhotoIdDecisionForIdentification =
      creditApplicationStateSelectors.isAwaitingPhotoIdDecisionForIdentification(creditApplication)

    if (creditApplication) {
      if (creditApplication.status === Enum.ECreditApplicationStatus.Cancelled)
        return `/creditApplication/${id as string}/cancelled`

      if (creditApplication.status === Enum.ECreditApplicationStatus.Completed)
        return `/creditApplication/${id as string}/completed`

      if (hasPrequalifyDecision && (canPostQualify || hasFailedPrequalify))
        return `/creditApplication/${id as string}/review-prequalifydecision`

      if (failedToConfirmApplicantIdentity || failedToConfirmCoApplicantIdentity)
        return `/creditApplication/${id as string}/verify-identity`

      if (hasFinalDecision && canReviewFinalDecision && !creditApplication.allIncomesConfirmed)
        return `/creditApplication/${id as string}/review-finaldecision`

      if ((customerFeedback as CustomerFeedback) && !hasRequiredDocumentPendingForUpload)
        return `/creditApplication/${id as string}/feedback-page`

      if (isReadyForFlinks || mustShowRequiredPhotoId || hasRequiredDocumentPendingForUpload)
        return `/creditApplication/${id as string}/income-verification`

      if (isReadyForWorksheet) return `/creditApplication/${id as string}/worksheet`

      if (
        (creditApplication.status === Enum.ECreditApplicationStatus.Active &&
          creditApplication.prequalificationDecision?.decision !== null &&
          creditApplication.finalDecision?.decision !== Enum.EFinalDecision.Pending &&
          creditApplication.finalDecision?.decision !== Enum.EFinalDecision.Error) ||
        isAwaitingPhotoIdDecisionForIdentification
      )
        return `/creditApplication/${id as string}/feedbackReview-page`
    }
    return `/creditApplication/${id as string}/credit-report-error`
  },
}
